export const environment = {
	production: false,
	devLoginEnabled: false,
	pathBackend: 'https://abogados-stg.gainkodex.com/api/v1',
};
